import { IWeatherForecastsService } from './Interfaces/IWeatherForecastsService';
import { WeatherForecast } from '../interfaces/WeatherForecast';
import { API } from '../helpers/API';

export class WeatherForecastsService implements IWeatherForecastsService {
  public async GetWeather(): Promise<WeatherForecast[]> {
    return (await API.GetAsync<WeatherForecast[]>('/weatherforecast')).data;
  }
}
